import { Section } from '@shared/components/Section';
import { curso } from '@curso/content/curso';

/**
 * Bloco 10. Responde: quem é o HCX e por que a inscrição acontece lá.
 *
 * Existe para evitar o vazamento mais bobo do funil: a pessoa clica, cai num
 * site com outra cara e outro logo, acha que errou o caminho e fecha.
 */
export function QuemOrganiza() {
  return (
    <Section
      id="quem-organiza"
      
      rotulo="Quem organiza"
      titulo={`Uma formação ${curso.instituicao}, em parceria com o ${curso.parceiro}`}
    >
      <p className="prosa">
        A Imersão HCRM é uma iniciativa da disciplina de Emergência do {curso.instituicao}, com
        comercialização e estrutura operacional pelo {curso.parceiro}. Quando as inscrições forem
        abertas, você será direcionado ao ambiente oficial do {curso.parceiro} para concluir sua
        matrícula. Ele tem outra identidade visual. Não é engano.
      </p>

      <p className="prosa mt-5">
        Atividades presenciais na {curso.local} ({curso.localCurto}).
      </p>

    </Section>
  );
}
